define('core/advice',[
    'underscore',
], function (_) {
    'use strict';

    // fn is a supporting object that implements around, before and after
    var fn = {
        around: function (base, wrapped) {
            return function () {
                var args = _.toArray(arguments);
                return wrapped.apply(this, [_.bind(base, this)].concat(args));
            };
        },
        before: function (base, before) {
            return fn.around(base, function () {
                var args = _.toArray(arguments);
                var orig = args.shift();

                before.apply(this, args);
                return orig.apply(this, args);
            });
        },
        after: function (base, after) {
            return fn.around(base, function () {
                var args = _.toArray(arguments);
                var orig = args.shift();
                var res = orig.apply(this, args);

                after.apply(this, args);
                return res;
            });
        },
    };

    // FlightJS advice-style mixins
    // https://gist.github.com/angus-c/2864853

    // mixin augments target object with around, before and after methods
    // method is the base method, advice is the augmenting function

    function withAdvice() {
        _.each(['before', 'after', 'around'], function (originalMethod) {
            this[originalMethod] = function (method, advice) {
                if (typeof this[method] === 'function')
                    this[method] = fn[originalMethod](this[method], advice);
                else
                    this[method] = advice;

                return this[method];
            };
        }, this);
    }

    return {
        withAdvice: withAdvice,
    };
});

